import React from 'react';
import { useContext } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { AuthContext } from '../Components/Contexts/UserContext';

const PrivateRoute = ({children}) => {
const { user, loading } = useContext(AuthContext)
const location = useLocation()

if(loading){
  return <h2 className='text-center mt-16'>Loading...</h2>
}

if(user?.uid){
  return children;
}

return <Navigate to="/login" state={{ from: location }} replace />;
};

export default PrivateRoute;